import CollectionApi from 'client/api/v2/CollectionApi';

class SoftwareAppsApi extends CollectionApi {
  constructor() {
    super('/api/v2/softwareapps', {
      skip: 0,
      limit: 50,
      sort: 'displayName', // Prepend with a '-' to reverse default sort direction
      filter: [{
        name: 'displayName',
        operator: 'search',
        value: '',
      }],
    });
  }

  importApps(payload) {
    return this.axios.post(`${this.baseUrl}/import/jobs`, payload);
  }

  /**
   * @param {string} appleAppId - Apple Application ID
   */
  reclaimLicenses(appleAppId) {
    return this.axios.post(`${this.baseUrl}/${appleAppId}/reclaim-licenses`, { headers: { 'Content-Type': 'application/json' } })
      .then(resp => ((resp && resp.data) || {}));
  }

  /**
   * @param {string} appleAppId - Apple Application ID
   */
  retryInstall(appleAppId, payload) {
    return this.axios.post(`${this.baseUrl}/${appleAppId}/retry-installation`, payload);
  }

  /**
   *  validate custom app URL
   * @param {string} url
   * @returns an object with all the information related to a custom app
   */
  validateCustomAppUrl(url) {
    return this.axios.post(`${this.baseUrl}/validate`, { url })
      .then(resp => ((resp && resp.data) || {}));
  }

  association(appId, params) {
    return this.axios.post(`${this.baseUrl}/${appId}/associations`, params)
      .then(resp => resp.data);
  }

  getApplicationCount(value) {
    return this.fetch(null, 1, null, null, null, [{
      name: 'packageManager',
      operator: 'eq',
      value,
    }]);
  }
}

export default new SoftwareAppsApi();
